import request from "./request";

const SupportService = {
    GetAll: async (status, skip, take, context, signal) => {
        return await request.sendRequest(`/ticket/user/status/${status}/page/${skip}/${take}`, context.token, signal);
    },
    GetTickets: async (status, skip, take, context, signal) => {
        return await request.sendRequest(`/ticket/assignee/status/${status}/page/${skip}/${take}`, context.token, signal);
    },
    Get: async (id, context, signal) => {
        return await request.sendRequest(`/ticket/details/${id}`, context.token, signal);
    },
    SetStatus: async (id, status, context) => {
        return await request.sendPutRequest(`/ticket/${id}/status/${status}`, context);
    },
    GetComments: async (id, context, signal) => {
        return await request.sendRequest(`/ticket/${id}/comments`, context.token, signal);
    },
    GetFile: async (id, context) => {
        return await request.sendRequest(`/ticket/${id}/attachment`, context.token);
    },
    GetCommentFile: async (id, context) => {
        return await request.sendRequest(`/ticket/comments/${id}/attachment`, context.token);
    },
    Reassign: async (id, agentId, context) => {
        return await request.sendPutRequest(`/ticket/${id}/reassign/${agentId}`, context);
    },
    Save: async (payload, context, signal) => {
        return await request.sendFormDataRequest(`/ticket`, payload, context, signal);
    },
    SaveComment: async (payload, context, signal) => {
        return await request.sendFormDataRequest(`/ticket/comment`, payload, context, signal);
    },
    Remove: async (id, context) => {
        return await request.sendDeleteRequest(`/ticket/${id}`, context.token);
    },
};

export default SupportService;
